import React, { useEffect, useState } from "react";
import { API } from "@/api/client";

/**
 * Displays an image whose URL requires Bearer auth.
 * Fetches as blob and renders via object URL.
 */
export default function AuthImage({ src, alt = "", className = "", fallback = null, style = undefined }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let currentUrl = null;
    const token = localStorage.getItem("wrm_token");
    // src can be either a full URL or a path like "/api/files/xxx"
    const url = src?.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.blob() : Promise.reject(r.status)))
      .then((b) => {
        if (cancelled) return;
        currentUrl = URL.createObjectURL(b);
        setBlobUrl(currentUrl);
      })
      .catch(() => !cancelled && setErr(true));
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [src]);

  if (err) return fallback;
  if (!blobUrl) return <div className={`bg-slate-100 animate-pulse ${className}`} />;
  return <img src={blobUrl} alt={alt} className={className} style={style} />;
}
